import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { handleSignInCapacitor } from 'identity/action-creators';
import SignInLoading from './SignInLoading';

class SignInCallbackCapacitor extends Component {
  componentDidMount() {
    this.props.actions.handleSignInCapacitor();
  }

  render() {
    return <SignInLoading />;
  }
}

SignInCallbackCapacitor.propTypes = {
  actions: PropTypes.shape({
    handleSignInCapacitor: PropTypes.func.isRequired
  }).isRequired
};

function mapDispatchToProps(dispatch) {
  const actions = {
    handleSignInCapacitor
  };
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}


export default connect(null, mapDispatchToProps)(SignInCallbackCapacitor);
